import {
  createContext,
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

export type CreatePostType = "CREATE_FEED_POST" | "CREATE_CLUB_POST";
export interface IPostContextState {
  open: boolean;
  clubId: string | undefined;
}

export const CreatePostContext = createContext<ICreatePostContext>(
  {} as ICreatePostContext
);

export const CreatePostProvider: FC<PropsWithChildren> = ({ children }) => {
  const [{ open, clubId }, setState] = useState<IPostContextState>({
    open: false,
    clubId: undefined,
  });

  const handleModalOpen = useCallback(
    (clubId?: string | undefined) => {
      setState({ open: true, clubId });
    },
    [setState]
  );

  const handleModalClose = useCallback(
    () => setState({ open: false, clubId: undefined }),
    [setState]
  );

  const value = useMemo(
    () => ({ open, clubId, handleModalOpen, handleModalClose }),
    [open, clubId, handleModalOpen, handleModalClose]
  );

  return (
    <CreatePostContext.Provider value={value}>
      {children}
    </CreatePostContext.Provider>
  );
};

export const useCreatePostContext = () => useContext(CreatePostContext);

export default CreatePostContext;
